import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  amount: {
    textAlign: 'right',
    display: 'block',
  },
  columnHeight: {
    height: 30,
  },
  rightAlignContainer: {
    flex: 1,
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
  },
  amountTotal: {
    fontWeight: 'bold',
    color: theme.palette.themePrimary,
  },
}));
